export default __webpack_public_path__ + "static/media/bye.9b859029.gif";